import Gallery from './Gallery'
import YoutubeLoader from './YoutubeLoader'

function install(Vue) {
  Vue.component(Gallery.name, Gallery)
  Vue.component(YoutubeLoader.name, YoutubeLoader)
}

export default { install }
